import React from 'react';
import { Card as CheckoutCard } from 'primereact/card';
import { RadioButton } from 'primereact/radiobutton';

import PropTypes from 'prop-types';
import deviceImg from '../assets/images/device.png';
import './checkoutCards.scss';

const calculateDueNowPrice = (option, parsedPrice, totalDevicesPrice, shippingPrice, peacockFeePrice) => {
  let finalPrice = totalDevicesPrice + shippingPrice + peacockFeePrice;

  if (option === 'package_2') {
    finalPrice += parsedPrice;
  }

  return finalPrice;
};

export default function CheckoutCards(props) {
  const {
    id,
    title,
    price,
    checkList,
    devicePrice,
    numberOfDevices,
    loading,
    shippingPriceFee,
    peacockFee,
    billingPlan,
    setShipping,
    shippingType,
  } = props;
  const totalDevicesPrice = id === 'package_1' ? devicePrice : 0;
  const parsedPrice = parseFloat(price?.split('$')[1]);
  const shippingPrice = numberOfDevices * shippingPriceFee;
  const canEditShipping = !!setShipping;

  const now = new Date();
  const peacockFreeEndDate = new Date('2023-09-01');
  const freePeacockFee = now < peacockFreeEndDate;

  const due45days = id === 'package_1' ? parsedPrice : null;
  const dueNowPrize = calculateDueNowPrice(id, parsedPrice, totalDevicesPrice, shippingPrice, freePeacockFee ? 0 : peacockFee);

  return (
    <div className="card_main_container" id="checkoutCard">
      <CheckoutCard>
        <div className="card-header peacock">
          <div>{title}</div>
          {billingPlan !== 'annually' ? (
            <div className="label-header">{billingPlan.toUpperCase()}</div>
          ) : (
            <div className="label-header highlight">{`${billingPlan.toUpperCase()} 30% OFF`}</div>
          )}
        </div>
        <div id="text-mark">
          <div className="pi">
            {checkList?.map(check => (
              <div key={check} className="textmark">
                <p>
                  <i className="pi pi-check p-mr-2" />
                  {check}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="image">
          <img alt="plan img" src={deviceImg} />
        </div>
        <>
          <div className="prices_container col-12 flex flex-column padding_0">
            <div className={`flex justify-content-between sub-titles peacock ${id === 'package_1' ? 'no-margin' : ''}`}>
              <p className="price_small_text">UPshow Package: </p>
              <label className="price_small"> {price}</label>
            </div>
            {id === 'package_1' && <p className="price-detail">(Due in 45 days, then charged monthly)</p>}
            <div>
              <div className="flex justify-content-between sub-titles peacock">
                <p className="price_small_text">Shipping & Handling:</p>
                <label className="price_small">{loading ? 'Loading...' : `$ ${shippingPriceFee * numberOfDevices}`}</label>
              </div>
              {canEditShipping && (
                <div className="flex justify-content-between shipping-options mb-4">
                  <div className="flex align-items-center">
                    <RadioButton value="ground" onChange={e => setShipping(e.value)} checked={shippingType === 'ground'} />
                    <label className={`shipping ${shippingType === 'ground' ? '' : 'disabled'}`}>Ground (5-7 days)</label>
                  </div>
                  <div className="flex align-items-center ml-2">
                    <RadioButton value="expedited" onChange={e => setShipping(e.value)} checked={shippingType === 'expedited'} />
                    <label className={`shipping ${shippingType === 'expedited' ? '' : 'disabled'}`}>Expedited (2-3 days)</label>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-content-between sub-titles peacock">
              <p className="price_small_text">Device Price:</p>
              <label className="price_small">{loading ? 'Loading...' : `$ ${totalDevicesPrice}`}</label>
            </div>
            <div className="flex justify-content-between sub-titles peacock no-margin">
              <p className="price_small_text">Peacock Fee:</p>
              <label className="price_small">{loading ? 'Loading...' : `$ ${peacockFee}/mo`}</label>
            </div>
            {freePeacockFee && <p className="price-detail">(Due Sep)</p>}
          </div>
          <div className="final_price_box flex justify-content-between padding_0 peacock">
            <div className="detailed-price">
              <p>Due Now:</p>
              <label>{loading ? 'Loading...' : `$ ${dueNowPrize}*`}</label>
            </div>
            {freePeacockFee && (
              <div className="detailed-price small">
                <p>Due Sep:</p>
                <label>{loading ? 'Loading...' : `$ ${peacockFee}*`}</label>
              </div>
            )}
            {due45days && (
              <div className="detailed-price small">
                <p>Monthly fee starting in 45 days:</p>
                <label>{loading ? 'Loading...' : `$ ${due45days}*`}</label>
              </div>
            )}
          </div>
          <p className="mt-4 text-left disclaimer">*Pricing excludes applicable sales taxes</p>
          <p className="mt-4 text-left disclaimer bold">
            *Casinos are not eligible for this {billingPlan === 'annually' ? 'Annual' : 'Monthly'} Package
          </p>
        </>
      </CheckoutCard>
    </div>
  );
}

CheckoutCards.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  price: PropTypes.string,
  checkList: PropTypes.array,
  devicePrice: PropTypes.number,
  shippingPriceFee: PropTypes.number,
  numberOfDevices: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  peacockFee: PropTypes.number,
  billingPlan: PropTypes.string,
  setShipping: PropTypes.func.isRequired,
  shippingType: PropTypes.string.isRequired,
};

CheckoutCards.defaultProps = {
  id: undefined,
  title: undefined,
  price: undefined,
  checkList: undefined,
  devicePrice: undefined,
  shippingPriceFee: undefined,
  loading: undefined,
  peacockFee: undefined,
  billingPlan: undefined,
};
